import {EventEmitter, Injectable} from "@angular/core";


@Injectable({providedIn: 'root'})
export class SiteEditService {
  newSiteSelected = new EventEmitter(true);
}
